import { createAction } from "redux-starter-kit";
import {
  DELETE_USER_NOTE_FAILURE,
  DELETE_USER_NOTE_REQUEST,
  DELETE_USER_NOTE_SUCCESS
} from "../types";

const deleteClientNote = (userId, noteId) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(DELETE_USER_NOTE_REQUEST)());
    await api.user.deleteUserNotes(noteId);
    dispatch(
      createAction(DELETE_USER_NOTE_SUCCESS)({
        userId,
        note: noteId
      })
    );
  } catch (err) {
    dispatch(createAction(DELETE_USER_NOTE_FAILURE)(err));
    throw err;
  }
};

export default deleteClientNote;
